import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'
import { UseFields } from 'piramis-base-components/src/components/Pi';
import { TriggerHelper, TriggerInputsSetups } from "@/components/TriggerSetup/logic/mixins/mixins";
import { TriggerCondition } from '../types/types';
import { SelectOptionData } from "piramis-base-components/src/components/Pi/types";

@Component
export class ConditionSetupView extends Mixins<UseFields, TriggerInputsSetups, TriggerHelper>(UseFields, TriggerInputsSetups, TriggerHelper) {
  @VModel({ 'type': Object }) conditionData!: TriggerCondition

  @Prop({ 'type': Boolean, 'default': false }) readonly disabled!: boolean

  filters(): Promise<Array<SelectOptionData>> {
    return Promise.resolve(this.conditionFilters)
  }

  messageContentTypes(): Promise<Array<SelectOptionData>> {
    return Promise.resolve(this.messageTypeValues)
  }

  replyState(): Promise<Array<SelectOptionData>> {
    return Promise.resolve(this.replyStateOptions)
  }
}
